module.exports = __webpack_public_path__ + "img/송내역 맛집.8c4e97ae.png";